<script>
export default {
  data(){
    return {
      itemSelected: null,
      baseUrl: "/api/sfa/v1/daily-closing/monitoring-salesman-not-yet-end-session",
      reason: {
        selected: null,
        options: [],
      },
      modalReason: {
        activeModalReason: false,
      },
    }
  },
  props: {
    data: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  methods: {
    onClickForceEnd(data){
      this.reason = {
        selected: null,
        options: [],
      }
      this.itemSelected = null
      this.getDataReason()
      this.modalReason.activeModalReason = !this.modalReason.activeModalReason
      this.itemSelected = {
        CustomerVisitID: data.ID,
        TerritoryID: data.TerritoryID,
        PersonalID: data.PersonalID,
        CustomerID: data.CustomerID
      }
    },
    onSendApproval(){
      if (!this.reason.selected) {
        return this.$vs.notify({
          title: "Error",
          text: "Please select a reason",
          color: "danger",
          position: "top-right",
        })
      }

      this.$vs.loading()
      this.$http.post(`${this.baseUrl}/force-end-session`, {
        customer_visit_id: this.itemSelected.CustomerVisitID,
        territory_id: this.itemSelected.TerritoryID,
        reason_id: this.reason.selected.ID,
        reason_text: this.reason.selected.reason,
        personal_id: this.itemSelected.PersonalID,
        customer_id: this.itemSelected.CustomerID,
      }).then((response) => {
        if(response.code == 200) {
          this.$vs.notify({
            title: "success",
            text: "Success Send Approval Force End Session Salesman",
            color: "success",
            position: "top-right",
          });
        } else {
          this.$vs.notify({
            title: "Error",
            text: response.message,
            color: "danger",
            position: "top-right",
          });
        }
      }).finally(() => {
        this.$vs.loading.close();
      })
    },
    getDataReason() {
      this.$vs.loading();
      this.$http
          .get("/api/oms/v1/sfa-master/reason-active", {
            params: {
              order: "code",
              sort: "asc",
              reason_group: "Force End Session",
              is_active: true
            },
          })
          .then((resp) => {
            if (resp.status == "success") {
              this.reason.options = resp.data.records;
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
            }
          });
    },
  }
}
</script>

<template>
  <div class="vx-row mb-2">
    <div class="core vx-col w-full mb-base">
        <vs-table stripe border :data="data" :sst="false" class="mt-2">
          <template slot="thead">
<!--            <vs-th>Action</vs-th>-->
            <vs-th>Customer</vs-th>
            <vs-th>Status</vs-th>
            <vs-th>Reason</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">
<!--              <vs-td>
                <vs-button
                    @click="onClickForceEnd(tr)"
                    size="small"
                    color="success"
                    icon-pack="feather"
                    icon="icon-navigation"
                    title="Force End"
                    style="margin-right: 5px"
                    v-show="tr.Flag === 0"
                />
              </vs-td>-->
              <vs-td>{{ tr.CustomerName }}</vs-td>
              <vs-td>{{ tr.Status }}</vs-td>
              <vs-td>{{ tr.VisitReason }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
    </div>

    <vs-prompt
        @accept="onSendApproval"
        :active.sync="modalReason.activeModalReason"
        title="Confirm"
        accept-text="Save"
    >
      <div class="con-example-prompt">
        <div>
          <span>Reason</span>
        </div>
        <div>
          <multiselect class="selectExample" v-model="reason.selected" :options="reason.options" label="reason" />
        </div>
      </div>
    </vs-prompt>
  </div>
</template>